export default "__VITE_ASSET__1a31743c__"